export default "__VITE_ASSET__IFbv0Al1__";